import React from 'react'
import { Provider } from './Context'
import { Layout } from './Layout'
import { Step } from './Step'

export const ActionProgress = ({ children, activeStep }: { children: React.ReactNode; activeStep: number }) => {
  return (
    <Provider activeStep={activeStep}>
      <Layout>{children}</Layout>
    </Provider>
  )
}

ActionProgress.Step = Step
